<template>
    <div class="card mb-2" :id="'heading-' + keyItem">
        <div
            class="card-header"
            style="border-bottom: none"
            :class="{ open: isOpen }"
        >
            <div
                class="text-left collapse-action"
                :data-target="'#' + keyItem"
                aria-expanded="true"
                :aria-controls="keyItem"
                data-toggle="collapse"
                @click.prevent="isOpen = !isOpen"
                ref="colHeader"
            >
                <span>{{ cardName[keyItem] || keyItem }}</span>
                <a class="collapse-action-icon">
                    <transition name="rotate">
                        <CustomIcon
                            :name="isOpen ? 'collapseOpen' : 'collapseClose'"
                        />
                    </transition>
                </a>
            </div>
            <!-- </h2> -->
        </div>
        <transition name="fade">
            <div
                :id="keyItem"
                class="accordion-collapse collapse"
                ref="colBody"
                :class="{ show: index == 0 }"
                :aria-labelledby="'heading-' + keyItem"
            >
                <transition-group name="fade" tag="div" class="card-body px-5">
                    <!-- new config start-->
                    <div
                        v-for="(item, $index) in Object.keys(data)"
                        :key="item + $index"
                        class="row align-items-start category-item"
                        :class="[
                            {
                                'border-top':
                                    $index != 0 &&
                                    visibleItem(item, themeProperties),
                            },
                            {
                                'pt-3': visibleItem(item, themeProperties),
                            },
                            { disabled: isDisabled(item) },
                        ]"
                    >
                        <template v-if="visibleItem(item, themeProperties)">
                            <div class="col-4">
                                <!-- {{ item }} -->
                                {{ getDisplayName(item, keyItem) }}
                            </div>
                            <div class="col-8">
                                <div class="d-flex justify-content-between">
                                    <component
                                        v-if="themeProperties[item].properties"
                                        :is="
                                            themeProperties[item].properties
                                                .component[keyItem] ||
                                            themeProperties[item].properties
                                                .component
                                        "
                                        :type="keyItem"
                                        :items="item"
                                        :image-name="
                                            themeProperties[item].properties
                                                .name || item
                                        "
                                        :name="item + keyItem"
                                        v-model="data[item]"
                                    ></component>
                                    <CustomTooltip content="Use default value">
                                        <a
                                            href="#"
                                            @click.prevent="
                                                $emit('reset', {
                                                    keyItem,
                                                    item,
                                                    currentCategory,
                                                })
                                            "
                                            class="text-muted"
                                        >
                                            <CustomIcon name="reset"
                                        /></a>
                                    </CustomTooltip>
                                </div>

                                <template
                                    v-if="
                                        themeProperties[item].properties
                                            .description &&
                                        currentCategory != 'global'
                                    "
                                >
                                    <div
                                        class="mt-1 pb-2 text-muted text-left"
                                        style="font-size: 0.75rem"
                                    >
                                        Description:
                                        {{
                                            toName(
                                                themeProperties[item].properties
                                                    .description,
                                                keyItem
                                            )
                                        }}
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>

                    <!-- new config end-->
                </transition-group>
            </div>
        </transition>
    </div>
</template>

<script>
import themeProperties from "../config/themeProperties.js";
import { cardName } from "../config/data.js";
import CustomIcon from "./CustomIcon.vue";
import CustomTooltip from "./CustomTooltip.vue";
import Color from "../theme-items/Color.vue";
import FontFamily from "../theme-items/FontFamily.vue";
import Numeric from "../theme-items/Numeric.vue";
import Switcher from "../theme-items/Switcher.vue";
import Select from "../theme-items/Select.vue";
import TextComponent from "../theme-items/TextComponent.vue";
import TextSize from "../theme-items/TextSize.vue";
import Transparency from "../theme-items/Transparency.vue";
import Scale from "../theme-items/Scale.vue";
import DateTime from "../theme-items/DateTime.vue";
import AlignmentHorizontal from "../theme-items/AlignmentHorizontal.vue";
import AlignmentVertical from "../theme-items/AlignmentVertical.vue";
import IntegerComponent from "../theme-items/IntegerComponent.vue";
import GeoJson from "../theme-items/GeoJson.vue";
import NoneComponent from "../theme-items/NoneComponent.vue";
import ImageComponent from "../theme-items/ImageComponent.vue";
import { EventBus } from "@/util/eventbus";

export default {
    props: [
        "target",
        "properties",
        "data",
        "keyItem",
        "index",
        "currentCategory",
    ],
    data() {
        return {
            themeProperties: themeProperties,
            cardName: cardName,
            isOpen: false,
        };
    },
    methods: {
        getDisplayName(item, key) {
            const name = this.themeProperties[item]?.properties?.displayName;
            return typeof name == "string" ? name : name[key] || name.default;
        },
        isDisabled(item) {
            if (Object.keys(this.data).includes("show")) {
                return (
                    !this.data?.show && item != "show" && item != "responsive"
                );
            } else {
                return false;
            }
        },
        visibleItem(name, item) {
            const properties = item[name]?.properties;
            if (!properties) {
                return false;
            }
            const vis = properties?.visible || "";
            if (typeof vis === "object") {
                // if (![name, ...vis].some((el) => Object.keys(this.data).includes(el))) {
                if (
                    ![name, ...vis].every((el) =>
                        Object.keys(this.data).includes(el)
                    )
                ) {
                    return this.data[name] || true;
                } else {
                    return false;
                }
            }
            if (
                ![name, ...[vis]].every((el) =>
                    Object.keys(this.data).includes(el)
                )
            ) {
                return true;
            }
            return this.data[vis];
        },
        eventBusListeren(type) {
            switch (type) {
                case "expand":
                    if (this.$refs.colHeader) {
                        this.$refs.colHeader.classList.value =
                            "text-left collapse-action";
                    }
                    if (this.$refs.colBody) {
                        this.$refs.colBody.classList.value =
                            "accordion-collapse collapse show";
                    }

                    this.isOpen = false;
                    break;
                case "collapse":
                    if (this.$refs.colHeader) {
                        this.$refs.colHeader.classList.value =
                            "text-left collapse-action collapsed";
                    }
                    if (this.$refs.colBody) {
                        this.$refs.colBody.classList.value =
                            "accordion-collapse collapse";
                    }

                    this.isOpen = false;
                    break;
                default:
                    break;
            }
        },
        toggleCollapse() {
            this.isOpen = !this.isOpen;
            // this.$refs.collapse("toggle");
        },
        toName(name, key) {
            if (!name) return null;
            return typeof name == "object" ? name[key] : name;
            // return typeof name != "undefined" ? name.map((el) => el)[0] : name;
        },
    },
    mounted() {
        this.isOpen = this.index == 0;
        EventBus.$on("collapsed", this.eventBusListeren);
    },
    components: {
        Color,
        FontFamily,
        Numeric,
        Switcher,
        Select,
        Transparency,
        TextComponent,
        TextSize,
        Scale,
        DateTime,
        IntegerComponent,
        AlignmentHorizontal,
        AlignmentVertical,
        GeoJson,
        NoneComponent,
        ImageComponent,
        CustomIcon,
        CustomTooltip,
    },
};
</script>

<style lang="scss">
.category-item.disabled {
    pointer-events: none;
    opacity: 0.4 !important;

    // .custom-switch{
    //   position: relative;
    //   &::after{
    //     content: '';
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     display: block;
    //     width: 100%;
    //     height: 100%;
    //     background-color: tomato;
    //   }
    // }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>